import {
  operations,
  Ok,
  client,
  handleDataOrError,
} from '@freckle/educator-entities/ts/fancy-api-client'

export type CourseMembershipAttrs = {
  id: number
  courseId: number
  studentId: number
}

const toCamel = ({
  id,
  'student-id': studentId,
  'course-id': courseId,
}: Ok<operations['getCourseMembershipsR']>[0]): CourseMembershipAttrs => ({
  id,
  studentId,
  courseId,
})

export const fetchCourseMemberships = (): Promise<Array<CourseMembershipAttrs>> =>
  client
    .GET('/2/course-memberships')
    .then(handleDataOrError)
    .then(data => data.map(toCamel))
